import React, {useRef, useEffect, useState} from "react";
import {useHistory} from "react-router-dom";
import {Paper, Button, Typography, Box,} from "@material-ui/core";
import {useFormik} from "formik";
import useStyles from "@/styles/alarmStyle";
import SearchInput from "@/components/SearchInput";
import {useTranslation} from "@/langs/useTranslation";
import {FormItem} from "@/components/Form";
import DateRangePicker from "@/components/DateRangePicker";
import {useGlobalState} from "@/GlobalProvider";
import SingleSelector from '@/components/SingleSelector'
import {InstallHistoryListDataTable} from "@/containers/ProfileConfig/History/InstallHistoryListDataTable";

const ProfileTemplateList = () => {
  const {t} = useTranslation();
  const classes = useStyles();
  const tableRef = useRef(null);
  const isReset = useRef(true);
  const [loading, setLoading] = useState(false);
  const [total, setTotal] = useState(0);

  const initialValues = {
    osType: "",
    status: -1,
    createTime: undefined,
    activeTime: undefined,
    updateTime: undefined,
    keywords: "",
  };

  const history = useHistory();
  const {currentCompanyId} = useGlobalState();

  const {values, handleChange, handleSubmit, handleReset} = useFormik({
    initialValues,
    onSubmit: () => {
      handleReloadDataTable();
    }
  });

  const getSearchParams = () => {
    const formValues = isReset.current ? initialValues : values;
    const {createTime, activeTime} = formValues;
    return {
      osType: formValues.osType ? formValues.osType : "",
      keywords: formValues.keywords,
      createdAtStart: createTime ? createTime[0]?.valueOf() : null,
      createdAtEnd: createTime ? createTime[1]?.valueOf() : null,
      effectedAtStart: activeTime ? activeTime[0]?.valueOf() : null,
      effectedAtEnd: activeTime ? activeTime[1]?.valueOf() : null,
    }
  }

  const reloadTableWithGroupId = () => {
    isReset.current = false;
    tableRef.current?.reload();
  };

  const resetTableWithGroupId = () => {
    isReset.current = true;
    tableRef.current?.reload();
  };

  const handleReloadDataTable = reset => {
    if (reset) {
      resetTableWithGroupId();
    } else {
      reloadTableWithGroupId();
    }
  };

  const resetQuery = () => {
    handleReset();
    handleReloadDataTable(true);
  };

  const handleLoaded = json => {
    setTotal(json.recordsTotal);
  };

  const typeOptions = [
    {id: "", name: t({defaultMessage: '全部'})},
    {id: "windows", name: t({defaultMessage: 'Windows'})},
    {id: "android", name: t({defaultMessage: 'Android'})}
  ]

  useEffect(() => {
    resetQuery();
  }, [currentCompanyId]);

  return (
    <div className={classes.main}>
      <form onSubmit={handleSubmit}>
        <Box display="flex" alignItems="center" marginBottom={1}>
          <Typography variant="h4">
            {t({defaultMessage: '安装历史'})}
          </Typography>
          <Box display="flex" alignItems="center" marginLeft="auto">
            <SearchInput
              placeholder={t({defaultMessage: "搜索"})}
              name="keywords"
              icon={null}
              value={values.keywords}
              onChange={handleChange}
              style={{marginRight: 16}}
            />
          </Box>
        </Box>
        <Paper elevation={0}>
          <div className={classes.tableHeader}>
            <div className={classes.tableQueryForm}>
              <FormItem
                label={t({defaultMessage: "类型"})}
                className={classes.formItem}
              >
                <SingleSelector
                  placeholder={t({defaultMessage: "全部"})}
                  options={typeOptions}
                  clearable
                  style={{width: 120}}
                  name="osType"
                  value={values.osType}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem
                label={t({defaultMessage: "最新更新时间"})}
                className={classes.formItem}
              >
                <DateRangePicker
                  name="createTime"
                  value={values.createTime}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem
                label={t({defaultMessage: "生效时间"})}
                className={classes.formItem}
              >
                <DateRangePicker
                  name="activeTime"
                  value={values.activeTime}
                  onChange={handleChange}
                />
              </FormItem>
              <FormItem className={classes.formItem}>
                <Button
                  variant="contained"
                  color="primary"
                  type="submit"
                  style={{marginRight: 8, width: 100}}
                >
                  {t({defaultMessage: "查询"})}
                </Button>
                <Button variant="outlined" onClick={resetQuery} style={{width: 100}}>
                  {t({defaultMessage: "重置"})}
                </Button>
              </FormItem>
            </div>
          </div>
          <InstallHistoryListDataTable
            ref={tableRef}
            getSearchParams={getSearchParams}
          />
        </Paper>
      </form>
    </div>
  );
};

export default ProfileTemplateList;
